import { API_ROUTES } from '@memorai/routes';
import type { UserProfile } from '@memorai/types';
import { apiFetch } from './client.js';

export type { UserProfile } from '@memorai/types';

export async function getCurrentUser(): Promise<UserProfile | null> {
    return apiFetch<UserProfile | null>(API_ROUTES.USER);
}
